import classNames from 'classnames';
import { DefaultRecordType } from 'rc-table/lib/interface';
import React from 'react';

export const ReportToPercent = (value: any, record: DefaultRecordType) => (
  <React.Fragment>
    <p
      className={classNames('mb-0', {
        'text-danger': record.isAllowedDirectorWeight,
      })}
    >
      {value}%
    </p>
  </React.Fragment>
);
